export { default as appletId } from './applet-id';
export { default as name } from './name';
export { default as description } from './description';
export { default as image } from './image';
export { default as logo } from './logo';
export { default as actions } from './actions';
export { default as customProperties } from './custom-properties';
